<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="102324"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item>
            <template #label>
              <span style="color: #1F75D5;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
            </template>
            <el-select v-model="editDialog.form.businessType" no="18">
              <el-option
                :label="$t('Information.AirExport')"
                value="AE"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span style="color: #1F75D5;">{{ $t('CargoMsg.Cargo_Code') }}</span>
            </template>
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item>
            <template #label>
              <span style="color: #1F75D5;">{{ $t('CargoMsg.Cargo_Describe') }}</span>
            </template>
            <el-input v-model="editDialog.form.description" no="description" />
          </el-form-item>
          <el-form-item :label="$t('Partners.b2bDisplay')">
            <el-radio-group v-model="editDialog.form.displayB2b">
              <el-radio :label="true">{{ $t('SeaExport.Display') }}</el-radio>
              <el-radio :label="false">{{ $t('SeaExport.NoDisplay') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  delSpecialOperationCode,
  getSpecialOperationCodeList,
  saveSpecialOperationCode
} from '@/api/basicData/specialOperationCode'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'SpecialOperationCode',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Describe'),
          field: 'description',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'businessType',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Partners.b2bDisplay'),
          field: 'displayB2b',
          width: 200,
          valueFormatter: params => this.showName(params.value)
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          businessType: 'AE',
          code: '',
          description: '',
          displayB2b: true,
          version: null
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },

    /**
     * 查询列表
     */
    async toQuery() {
      const loading = getLoading()
      const res = await getSpecialOperationCodeList(this.filter).finally(() => loading.close())
      if (this.gridApi) {
        this.gridApi.setRowData(res.data.list)
      } else {
        this.rowData = res.data.list
      }
      this.total = Number(res.data.total)
    },

    /**
     * 显示编辑弹窗
     * @param {boolean} isNew 是否新增
     */
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          businessType: 'AE',
          code: '',
          description: '',
          displayB2b: true,
          version: 1
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('SeaExport.specialOperationCode')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('SeaExport.specialOperationCode')
      }
      this.editDialog.visible = true
    },

    /**
     * 保存新增/编辑
     */
    async save() {
      const loading = getLoading()
      const form = this.editDialog.form
      if (!form.code) {
        loading.close()
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.description) {
        loading.close()
        this.$message.warning(this.$t('Information.ContentDescriptionCannotBeEmpty'))
        return
      }
      saveSpecialOperationCode(form).then(async res => {
        if (res.ok) {
          if (!form.uuid) {
            this.filter.pageNum = 1
          }
          await this.toQuery()
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }
        this.editDialog.visible = false
      }).finally(() => {
        loading.close()
      })
    },

    /**
     * 删除选中的特殊操作码
     * @param {Array} rows 选中的行数据
     */
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.syncRemove(rows)
      }).catch(() => { })
    },
    async syncRemove(rows) {
      const uuids = rows.map(val => val.uuid)
      await delSpecialOperationCode(uuids).catch(() => {
        this.filter.pageNum = 1
        this.toQuery()
      })

      this.filter.pageNum = 1
      await this.toQuery()
      this.$message.success(this.$t('common.tips.deleteSuccess'))
    },

    /**
     * 格式化 B2B 显示字段
     * @param {boolean} displayB2b 是否显示 B2B
     * @returns {string} 格式化后的字段
     */
    showName(displayB2b) {
      return displayB2b ? this.$t('Message.Yes') : this.$t('Message.No')
    }
  }
}
</script>

<style scoped>
</style>
